import {
  Row,
  Col,
  Form,
  Button,
  DatePicker,
  TimePicker,
  InputNumber,
  Radio,
  Typography,
  Carousel,
  Space,
  Card,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CalendarButton from "../../components/CalendarButton";
import CaregiverDisplay from "../../components/CaregiverDisplay";
import Loading from "../../components/Loading";
import SubmitButton from "../../components/SubmitButton";
import computer from "../../images/laptop-graphic.png";
import { careTypeList } from "../../utils/careCategoryOptions";
import Spacer from "../../components/Spacer";

import "./Home.css";

const Home = () => {
  const [caretypes, setCaretypes] = useState([]);

  useEffect(() => {
    let values = [];
    Object.keys(careTypeList).forEach((care) => {
      values.push(careTypeList[care]);
    });

    setCaretypes(values);
  }, []);

  const navigate = useNavigate();

  const handleClick = (type) => {
    let page = "/caregivers";
    let target = type ? `${page}?caretype=${type}` : page;
    navigate(target);
  };

  const cardStyle = {
    textAlign: "center",
    background: "#e3f0fc",
    height: "100%",
  };

  return (
    <>
      <Typography.Title level={1} style={{ textAlign: "center" }}>
        On-Demand Virtual Care
      </Typography.Title>

      <div className="jumbotron purple">
        <Row align="middle" gutter={[20, 20]}>
          <Col xs={24} md={12}>
            <Carousel autoplay autoplaySpeed={5000} adaptiveHeight>
              {caretypes.map((caretype) => (
                <div key={caretype.value}>
                  <div className="carousel-content">
                    <Typography.Title level={2}>
                      {caretype.label}
                    </Typography.Title>
                    <Typography.Paragraph strong>
                      {caretype.description}
                    </Typography.Paragraph>
                    <Typography.Paragraph>
                      {caretype.extra}
                    </Typography.Paragraph>
                    <Button
                      type="primary"
                      size="large"
                      onClick={() => handleClick(caretype.value)}
                    >
                      {caretype.caregiverLabel}
                    </Button>
                  </div>
                </div>
              ))}
            </Carousel>
          </Col>
          <Col sx={24} md={12}>
            <img
              src={computer}
              style={{ maxWidth: "100%", marginLeft: "auto", display: "block" }}
            />
          </Col>
        </Row>
      </div>

      <Spacer />

      <Row gutter={[20, 20]}>
        <Col xs={24} md={8}>
          <Card style={cardStyle}>
            <Typography.Title level={2}>Hundreds of options</Typography.Title>
            <Typography.Paragraph>
              We have hundreds of providers waiting to help you.
            </Typography.Paragraph>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card style={cardStyle}>
            <Typography.Title level={2}>Help wherever you are</Typography.Title>
            <Typography.Paragraph>
              Attend virtual care sessions from your web browser - all you need
              is an internet connection.
            </Typography.Paragraph>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card style={cardStyle}>
            <Typography.Title level={2}>First session free</Typography.Title>
            <Typography.Paragraph>
              Your first session is on us!
            </Typography.Paragraph>
          </Card>
        </Col>
        <Col xs={24} md={{ span: 8, offset: 8 }} lg={{ span: 4, offset: 10 }}>
          <Button
            block
            onClick={() => handleClick()}
            type="primary"
            size="large"
          >
            View Providers
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default Home;
